import { useReportTopStrip } from '@/atoms/top-strip-atoms';
import { getUsageLimitsHelpUrl } from '@/components/constants/billing-urls';
import { useIsHeidi2OptInEnabled, useIsHeidi2TrialEndEnabled } from '@/features/flags';
import { useIsClinicalRecordingActive } from '@/hooks/useIsClinicalRecordingActive';
import {
  trackComplimentaryTrialEndBannerClick,
  trackComplimentaryTrialEndBannerViewed,
} from '@/models/analytics/features/complimentary-trial-end-analytics';
import { isAppleCompliantBuild } from '@/utils/appConfiguration';
import {
  ComplimentaryTrialEndBanner,
  type ComplimentaryTrialEndBannerPorts,
} from '@heidi/commerce';

import { useOpenHomeTasks } from './use-open-home-tasks';

// The running timer lives in the Rematch store; the session and Chronicle
// signals already cover a recording in progress, paused or not.
const useIsRecordingActive = () => useIsClinicalRecordingActive(false);

const COMPLIMENTARY_TRIAL_END_BANNER_PORTS: ComplimentaryTrialEndBannerPorts = {
  useIsHeidi2OptInEnabled,
  useIsHeidi2TrialEndEnabled,
  useReportTopStrip,
  useIsClinicalRecordingActive: useIsRecordingActive,
  useOpenHomeTasks,
  isAppleCompliantBuild,
  getUsageLimitsHelpUrl,
  trackComplimentaryTrialEndBannerViewed,
  trackComplimentaryTrialEndBannerClick,
};

/** Layout strip for the last week of complimentary Heidi II Max usage. */
export const ComplimentaryTrialEndBannerHost = () => (
  <ComplimentaryTrialEndBanner ports={COMPLIMENTARY_TRIAL_END_BANNER_PORTS} />
);
